import { Component } from "react";
import Uppy from '@uppy/core'
import { DashboardModal } from '@uppy/react'
import Transloadit from '@uppy/transloadit';
import GoogleDrive from '@uppy/google-drive';
import Instagram from '@uppy/instagram';
import Url from '@uppy/url';
import Webcam from '@uppy/webcam';
import $ from 'jquery'
import '@uppy/core/dist/style.css'
import '@uppy/dashboard/dist/style.css';
import { UPPY_AWS_KEY, UPPY_AWS_SECRET_KEY, UPPY_BUCKET, UPPY_CAMPAION_URL, UPPY_KEY } from "../../../../../actions/constant";
import { toast } from "react-toastify";
import { TOAST_ERROR } from "../../../../../utils";

const uppyKey = UPPY_KEY;
const uppyBucket =  UPPY_BUCKET;
const uppyAwsKey =  UPPY_AWS_KEY;
const uppyAwsSecret =  UPPY_AWS_SECRET_KEY;
const companionUrl = UPPY_CAMPAION_URL;


class PopupUpload extends Component {

    constructor(props) {

        super(props);

        this.uppyPostEdit = new Uppy({
            debug: true,
            autoProceed: true,
            restrictions: {
                maxFileSize: 5000000, maxNumberOfFiles: 1, minNumberOfFiles: 1, allowedFileTypes: ['image/*'],
            },
            onBeforeUpload: (files) => {
                try {
                    const fileKeys = Object.keys(files);

                    if (files[fileKeys[0]].meta.type.includes("image")) {
                        this.remove_StatusBar();
                    }
                    } catch (error) {
                }
            },
        })
            .use(Transloadit, {
                target: '#a',
                params: {
                    auth: {
                        key: uppyKey
                    },
                    steps: {
                          store: {
                            robot: "/wasabi/store",
                            bucket_region: "us-west-1",
                            bucket: uppyBucket,
                            key: uppyAwsKey,
                            secret: uppyAwsSecret,
                            path: 'media/tmpimages/${file.id}.${file.ext}',
                          },
                    }
                },
                waitForEncoding: true
            })
            .use(Instagram, { target: Uppy.Dashboard, companionUrl: companionUrl })
            .use(GoogleDrive, { target: Uppy.Dashboard, companionUrl: companionUrl })
            .use(Url, { target: Uppy.Dashboard, companionUrl: companionUrl })
            .use(Webcam, { target: Uppy.Dashboard, companionUrl: companionUrl })

            .on("restriction-failed", (file, error) => {

                let fileType = file.type.split('/');

                if (fileType[0] != 'image') {
                    toast.error("You can only upload Image", {autoClose: 2000});
                    return false;
                }

                if (file.size > 5000000) {
                    toast.error("Maximum allowed size of 4.8 MB", {autoClose: 2000});
                    return false;
                }
            })

        this.onClickToOpen = this.onClickToOpen.bind(this)
        this.onClickToClose = this.onClickToClose.bind(this)
    }


    state = {
        filename: null,
        modalOpen: false,
        mediaTyp: null,
        updateFile: 0,
        thumb_file: null,
        selected: ""
    }

      componentDidMount() {

        const { popStatus } = this.props

          if(popStatus!="background"){
              this.uppyPostEdit.on('file-added', (file) => {  

                const data = file.data 
                const url = URL.createObjectURL(data)
                const image = new Image()
                image.src = url
                
                image.onload = () => {
                    if(image.height>210){
                        TOAST_ERROR("For optimal display, the banner height should not exceed 200px.")
                    this.uppyPostEdit.cancelAll();
                    return false
                    }
                }
            }) 
         }    

        this.uppyPostEdit.on('transloadit:result', (stepName, result) => {

            this.setState({ selectedFile: `${result.id}.${result.ext}`, mediaTyp: result.type }, () => {
                setTimeout(() => {
                    const { setonUpload, uploadFile } = this.props;
                    this.setState({ modalOpen: false },()=>{
                        setonUpload(false);
                        uploadFile(`${result.id}.${result.ext}`);
                    })
                    this.uppyPostEdit.cancelAll()
                }, 300)
            })
        })
    }


    setpostFile = (imageName) => {
        this.setState({ filename: imageName, updateFile: 1 })
    }


    onClickToOpen = () => {
        this.setState({ modalOpen: true })
        $(".uppy-Dashboard-close").click(() => {
            this.uppyPostEdit.cancelAll()
            this.setState({ modalOpen: false })
            this.props.setonUpload(false)
        })

        // setTimeout(() => {
        //     this.updateProgressindicators();
        // }, 10)

    }


    // updateProgressindicators = () => {
    //     $(".uppy-Dashboard-progressindicators").remove();
    // }


    // remove_StatusBar = () => {
    //     $('.uppy-StatusBar').remove();
    // }


    onClickToClose = () => { 
        this.uppyPostEdit.cancelAll()
        this.setState({ modalOpen: false })
    }

    componentWillUnmount() { 
        this.uppyPostEdit.cancelAll()
        this.uppyPostEdit.close({ reason: 'unmount' })
        this.setState({ modalOpen: false })
    }


    render() {

        const { modalOpen } = this.state;
        const { onUpload } = this.props

        if (onUpload && !modalOpen) {
            this.onClickToOpen();
        }

        return (
            <DashboardModal
                animateOpenClose={true}
                proudlyDisplayPoweredByUppy={false}
                inline={false}
                showProgressDetails={true}
                hideCancelButton={false}
                height={750}
                browserBackButtonClose={true}
                showRemoveButtonAfterComplete={false}
                uppy={this.uppyPostEdit}
                open={modalOpen}
                onRequestCloseModal={this.onClickToClose}
                closeAfterFinish={true}
                doneButtonHandler={this.doneButtonHandler}
                plugins={["Instagram", "GoogleDrive", "Url", "Webcam"]}
            />
        );
    }
}

export default PopupUpload;
